import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { SharedDataAccessParsersModule } from '@se-po/shared-data-access-parsers'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeHeaderModule } from 'se-fe-header'
import { SeFePageModule } from 'se-fe-page'

import { SeFeDocsExampleModule } from 'se-fe-docs-example'
import { SeFeDocsTableModule } from 'se-fe-docs-table'
import { SharedUiPersonaChoiceModule } from '../lib/shared-ui-persona-choice.module'
import { PersonaChoiceDocsComponent } from './persona-choice-docs/persona-choice-docs.component'
import { PersonaChoiceExampleWithDefaultFieldsComponent } from './persona-choice-docs/persona-choice-example-with-default-fields.component'
import {
  PersonaChoiceExampleWithRequiredFieldsComponent
} from './persona-choice-docs/persona-choice-example-with-required-fields.component'
import { PersonaChoiceExampleComponent } from './persona-choice-docs/persona-choice-example.component'

@NgModule({
  imports: [
    CommonModule,
    SeFeCardModule,
    SeFeDocsExampleModule,
    SeFeDocsTableModule,
    SeFeHeaderModule,
    SeFePageModule,
    SharedDataAccessParsersModule,
    SharedUiPersonaChoiceModule
  ],
  declarations: [
    PersonaChoiceDocsComponent,
    PersonaChoiceExampleComponent,
    PersonaChoiceExampleWithDefaultFieldsComponent,
    PersonaChoiceExampleWithRequiredFieldsComponent
  ],
  exports: [PersonaChoiceDocsComponent],
})
export class SharedUiPersonaChoiceDocsModule {}
